import Cookies from 'js-cookie'
import store from '../store'
export const baseUrl = 'http://10.0.0.123:8081/wzkj-api'
/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16))
}

/**
 * 获取svg图标(id)列表
 */
export function getIconList () {
  const res = []
  const list = document.querySelectorAll('svg symbol')
  for (let i = 0; i < list.length; i++) {
    res.push(list[i].id)
  }

  return res
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'pid') {
  const res = []
  const temp = {}
  for (let i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (let k = 0; k < data.length; k++) {
    if (!temp[data[k][pid]] || data[k][id] === data[k][pid]) {
      res.push(data[k])
      continue
    }
    if (!temp[data[k][pid]].children) {
      temp[data[k][pid]].children = []
    }
    temp[data[k][pid]].children.push(data[k])
    data[k]._level = (temp[data[k][pid]]._level || 0) + 1
  }
  return res
}
/**
 * 判断当前设备是ios还是安卓
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function isAndroidOrIOS() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    return "android"
  }
  if (isiOS) {
    return "ios"
  }
  return false
}
